export default __webpack_public_path__ + "static/media/button-close.e85d9a42.png";